import { createReducer } from '@ngrx/store';

import { produceOn } from 'app/_state/produce-on';

import { toEntityConnectionTableKey } from './entity-connection-table-key';
import * as ACTIONS from './entity-connection.actions';
import { initialState } from './entity-connection.state';

const _entityConnectionReducers = createReducer(initialState,
  // Set if the connection box is filtered to active or inactive
  produceOn(ACTIONS.SET_EC_TABLE_SHOW_INACTIVE, (state, props) => {
    const key = toEntityConnectionTableKey(props.payload?.key);
    if (!state.entity_connection_tables[key]) {
      state.entity_connection_tables[key] = {
        includeInactive: props.payload.value.includeInactive,
      };
    } else {
      state.entity_connection_tables[key].includeInactive = props?.payload.value.includeInactive;
    }
  })
);

export function entityConnectionReducers(state, action) {
  return _entityConnectionReducers(state, action);
}
